// extracted by mini-css-extract-plugin
export default {"formItems":"NoteForm_formItems__m3EVd","formItems__button":"NoteForm_formItems__button__Tg7+p"};